/** About page text, written by hand in English and Tamil. */
const ABOUT_EN = {
  eyebrow: "About Vartha",
  title: "News, knowledge and connections for local business.",
  lead: "Vartha Business Network is a business media platform that tells the stories of local businesses and shares the practical know-how they need to grow.",
  mission: {
    eyebrow: "Our mission",
    text: "Every local business has a story worth telling and a lesson worth sharing. We exist to make both easy to find.",
    body: "Big-city media rarely covers the shop, workshop or start-up around the corner. Vartha does. We bring together founders, makers, suppliers and advisers in one place, in Tamil and English, so a good idea in one town can help a business in the next.",
  },
  ticker: ["Business Stories", "Achievements", "Strategies", "New Products", "Supplier Enquiries", "Business Videos", "Business Q&A", "Resources", "Business Directory"],
  stats: [
    { value: 9, label: "kinds of content in one place" },
    { value: 9, label: "resource categories, from GST to start-ups" },
    { value: 2, label: "languages: Tamil and English" },
  ],
  coverEyebrow: "What you will find",
  coverTitle: "Everything a growing business reads, asks and shares.",
  cover: [
    { to: "/stories", title: "Business Stories", text: "Growth journeys and company backgrounds, told properly." },
    { to: "/achievements", title: "Achievements", text: "Awards, certifications and milestones worth celebrating." },
    { to: "/strategies", title: "Strategies", text: "Marketing and growth approaches, with the lessons learnt." },
    { to: "/products", title: "New Products", text: "Launches and upcoming products from local makers." },
    { to: "/enquiries", title: "Supplier Enquiries", text: "What businesses are looking for, and who can supply it." },
    { to: "/videos", title: "Business Videos", text: "Short films from founders and factory floors." },
    { to: "/community", title: "Business Q&A", text: "Ask a question, share an answer, help a neighbour." },
    { to: "/resources", title: "Resources", text: "Guides on marketing, GST, tax, MSME schemes and finance." },
    // { to: "/businesses", title: "Business Directory", text: "Find and get to know the businesses around you." },
  ],
  valuesEyebrow: "What we believe",
  valuesTitle: "Four ideas guide everything we publish.",
  values: [
    { title: "Local first", text: "We start with the businesses closest to home and the problems they actually face." },
    { title: "Practical over fancy", text: "Clear, useful know-how you can act on this week, not jargon." },
    { title: "Open to everyone", text: "Reading is open to all, and anyone can ask a question or share an answer." },
    { title: "Honest and careful", text: "We label guidance as guidance and encourage you to check official sources." },
  ],
  journeyEyebrow: "How it works",
  journeyTitle: "From curious to connected in four steps.",
  journey: [
    { title: "Discover", text: "Browse stories, products and businesses from your community." },
    { title: "Learn", text: "Read practical resources and watch how others solved the same problem." },
    { title: "Connect", text: "Ask questions, answer others and respond to supplier enquiries." },
    { title: "Grow", text: "Share your own story and let the right customers and partners find you." },
  ],
  ctaTitle: "Be part of the network.",
  ctaText: "Create an account to ask questions, answer others and put your business on the map.",
  ctaPrimary: "Join the Network",
  ctaSecondary: "Browse businesses",
};

const ABOUT_TA = {
  eyebrow: "வார்த்தா பற்றி",
  title: "உள்ளூர் வணிகங்களுக்கான செய்திகள், அறிவு மற்றும் இணைப்புகள்.",
  lead: "வார்த்தா பிசினஸ் நெட்வொர்க் என்பது உள்ளூர் வணிகங்களின் கதைகளைச் சொல்லி, அவை வளரத் தேவையான நடைமுறை அறிவைப் பகிரும் வணிக ஊடகத் தளம்.",
  mission: {
    eyebrow: "எங்கள் நோக்கம்",
    text: "ஒவ்வொரு உள்ளூர் வணிகத்திற்கும் சொல்லத்தக்க ஒரு கதையும், பகிரத்தக்க ஒரு பாடமும் உண்டு. இரண்டையும் எளிதாகக் கண்டுபிடிக்க வைப்பதே எங்கள் பணி.",
    body: "பெருநகர ஊடகங்கள் பெரும்பாலும் அடுத்த தெருவில் இருக்கும் கடை, பட்டறை அல்லது புதிய தொழிலைப் பற்றிப் பேசுவதில்லை. வார்த்தா பேசுகிறது. தொழில்முனைவோர், உற்பத்தியாளர்கள், சப்ளையர்கள் மற்றும் ஆலோசகர்களை தமிழிலும் ஆங்கிலத்திலும் ஒரே இடத்தில் இணைக்கிறோம்; ஒரு ஊரின் நல்ல யோசனை அடுத்த ஊரின் வணிகத்திற்கு உதவட்டும்.",
  },
  ticker: ["வணிகக் கதைகள்", "சாதனைகள்", "உத்திகள்", "புதிய தயாரிப்புகள்", "சப்ளையர் விசாரணைகள்", "வணிக வீடியோக்கள்", "வணிக கேள்வி பதில்", "வளங்கள்", "வணிக விவரக்குறிப்பு"],
  stats: [
    { value: 9, label: "வகை உள்ளடக்கங்கள், ஒரே இடத்தில்" },
    { value: 9, label: "வளங்கள் பிரிவுகள், ஜிஎஸ்டி முதல் தொடக்க நிறுவனங்கள் வரை" },
    { value: 2, label: "மொழிகள்: தமிழ் மற்றும் ஆங்கிலம்" },
  ],
  coverEyebrow: "இங்கே என்ன கிடைக்கும்",
  coverTitle: "வளரும் வணிகம் படிக்க, கேட்க, பகிர வேண்டிய அனைத்தும்.",
  cover: [
    { to: "/stories", title: "வணிகக் கதைகள்", text: "வளர்ச்சிப் பயணங்களும் நிறுவனப் பின்னணியும், முழுமையாக." },
    { to: "/achievements", title: "சாதனைகள்", text: "கொண்டாடத்தக்க விருதுகள், சான்றிதழ்கள் மற்றும் மைல்கற்கள்." },
    { to: "/strategies", title: "உத்திகள்", text: "சந்தைப்படுத்தல் மற்றும் வளர்ச்சி அணுகுமுறைகள், கற்ற பாடங்களுடன்." },
    { to: "/products", title: "புதிய தயாரிப்புகள்", text: "உள்ளூர் தயாரிப்பாளர்களின் புதிய மற்றும் வரவிருக்கும் தயாரிப்புகள்." },
    { to: "/enquiries", title: "சப்ளையர் விசாரணைகள்", text: "வணிகங்கள் எதைத் தேடுகின்றன, யார் வழங்க முடியும் என்பது." },
    { to: "/videos", title: "வணிக வீடியோக்கள்", text: "தொழில்முனைவோர் மற்றும் உற்பத்திக் கூடங்களின் குறும்படங்கள்." },
    { to: "/community", title: "வணிக கேள்வி பதில்", text: "கேள்வி கேளுங்கள், பதில் பகிருங்கள், அண்டை வணிகருக்கு உதவுங்கள்." },
    { to: "/resources", title: "வளங்கள்", text: "சந்தைப்படுத்தல், ஜிஎஸ்டி, வரி, MSME திட்டங்கள் மற்றும் நிதி வழிகாட்டிகள்." },
    // { to: "/businesses", title: "வணிக விவரக்குறிப்பு", text: "உங்கள் அருகிலுள்ள வணிகங்களைக் கண்டு அறிந்துகொள்ளுங்கள்." },
  ],
  valuesEyebrow: "நாங்கள் நம்புவது",
  valuesTitle: "நாங்கள் வெளியிடும் அனைத்தையும் நான்கு எண்ணங்கள் வழிநடத்துகின்றன.",
  values: [
    { title: "முதலில் உள்ளூர்", text: "வீட்டிற்கு மிக அருகிலுள்ள வணிகங்களிலிருந்தும், அவை உண்மையில் எதிர்கொள்ளும் சிக்கல்களிலிருந்தும் தொடங்குகிறோம்." },
    { title: "அலங்காரத்தை விட பயன்", text: "இந்த வாரமே செயல்படுத்தக்கூடிய தெளிவான, பயனுள்ள அறிவு; கடினமான சொற்கள் இல்லை." },
    { title: "அனைவருக்கும் திறந்தது", text: "வாசிப்பது அனைவருக்கும் திறந்தது; யார் வேண்டுமானாலும் கேள்வி கேட்கலாம், பதில் பகிரலாம்." },
    { title: "நேர்மையும் கவனமும்", text: "வழிகாட்டுதலை வழிகாட்டுதல் என்றே குறிப்பிடுகிறோம்; அதிகாரப்பூர்வ ஆதாரங்களைச் சரிபார்க்க ஊக்குவிக்கிறோம்." },
  ],
  journeyEyebrow: "எப்படிச் செயல்படுகிறது",
  journeyTitle: "ஆர்வத்திலிருந்து இணைப்பு வரை நான்கு படிகளில்.",
  journey: [
    { title: "கண்டறியுங்கள்", text: "உங்கள் சமூகத்தின் கதைகள், தயாரிப்புகள் மற்றும் வணிகங்களை உலாவுங்கள்." },
    { title: "கற்றுக்கொள்ளுங்கள்", text: "நடைமுறை வளங்களைப் படித்து, மற்றவர்கள் அதே சிக்கலை எப்படித் தீர்த்தார்கள் என்று பாருங்கள்." },
    { title: "இணையுங்கள்", text: "கேள்விகள் கேளுங்கள், மற்றவர்களுக்குப் பதிலளியுங்கள், சப்ளையர் விசாரணைகளுக்குப் பதில் தாருங்கள்." },
    { title: "வளருங்கள்", text: "உங்கள் கதையைப் பகிருங்கள்; சரியான வாடிக்கையாளர்களும் கூட்டாளர்களும் உங்களைக் கண்டுகொள்ளட்டும்." },
  ],
  ctaTitle: "நெட்வொர்க்கின் ஒரு பகுதியாகுங்கள்.",
  ctaText: "கணக்கை உருவாக்கி கேள்விகள் கேளுங்கள், மற்றவர்களுக்குப் பதிலளியுங்கள், உங்கள் வணிகத்தை வரைபடத்தில் இடம்பெறச் செய்யுங்கள்.",
  ctaPrimary: "நெட்வொர்க்கில் இணையுங்கள்",
  ctaSecondary: "வணிகங்களை உலாவுங்கள்",
};

export const ABOUT = { en: ABOUT_EN, ta: ABOUT_TA };
